module.exports = __webpack_public_path__ + "img/client-ragout.acb012e1.png";